/*
 * section-fc-recipe-books.js — Recipe Books collection section
 * -----------------------------------------------------------------------
 * Two jobs:
 *   1. Reveal the floating bundle bar once the bundle card scrolls out of view.
 *   2. Add to cart over ajax and hand off to the theme's slide-in cart.
 *
 * Integration notes (Eurus):
 *   - The theme re-renders cart sections from the /cart/add.js `sections`
 *     response. We reuse its own `xCartHelper.getSectionsToRender()` list so we
 *     stay in step with whatever the theme considers cart UI, and degrade to a
 *     plain /cart redirect when Alpine isn't up yet.
 *   - Eurus defers most of its JS until the first interaction, which is what
 *     causes the "tap twice" bug. Our buttons are real <button>s wired on
 *     'click' from this standalone file, so they are live before that init runs.
 */
(function () {
  'use strict';

  function sectionInnerHTML(html, selector) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var el = doc.querySelector(selector);
    return el ? el.innerHTML : null;
  }

  function alpineStore(name) {
    try {
      if (window.Alpine && typeof Alpine.store === 'function') return Alpine.store(name);
    } catch (e) { /* Alpine not ready */ }
    return null;
  }

  function afterAdd(response) {
    var helper = alpineStore('xCartHelper');
    var miniCart = alpineStore('xMiniCart');

    if (helper && typeof helper.getSectionsToRender === 'function' && response && response.sections) {
      helper.getSectionsToRender().forEach(function (section) {
        section.selector.split(',').forEach(function (selector) {
          var host = document.querySelector(selector);
          if (!host || !response.sections[section.id]) return;
          var markup = sectionInnerHTML(response.sections[section.id], selector);
          if (markup !== null) host.innerHTML = markup;
        });
      });
    }

    if (helper && typeof helper.updateEstimateShippingFull === 'function') {
      helper.updateEstimateShippingFull();
    }

    document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));

    if (miniCart && typeof miniCart.openCart === 'function') {
      miniCart.openCart();
    } else {
      // Alpine hasn't booted (or the drawer is disabled) — send them to the cart
      // rather than silently succeeding with no visible feedback.
      window.location.href = '/cart';
    }
  }

  function addToCart(button) {
    var variantId = button.getAttribute('data-variant-id');
    if (!variantId || button.classList.contains('is-loading')) return;

    var body = { items: [{ id: Number(variantId), quantity: 1 }] };
    var helper = alpineStore('xCartHelper');
    if (helper && typeof helper.getSectionsToRender === 'function') {
      body.sections = helper.getSectionsToRender().map(function (s) { return s.id; }).join(',');
    }

    button.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error((res.data && res.data.description) || 'Add to cart failed');
        afterAdd(res.data);
      })
      .catch(function (err) {
        console.error('[fc-recipe-books]', err);
        window.location.href = '/cart';
      })
      .then(function () { button.classList.remove('is-loading'); });
  }

  function initSection(root) {
    if (root.dataset.frbReady === '1') return;
    root.dataset.frbReady = '1';

    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-frb-add]');
      if (!button || button.getAttribute('aria-disabled') === 'true') return;
      event.preventDefault();
      addToCart(button);
    });

    var bar = root.querySelector('[data-frb-bar]');
    var bundle = root.querySelector('[data-frb-bundle]');
    if (!bar || !bundle) return;

    if (!('IntersectionObserver' in window)) {
      bar.classList.add('is-visible');
      return;
    }

    // Show the bar only once the bundle card itself is off screen, so we never
    // duplicate a CTA the shopper can already see.
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting);
      });
    }, { rootMargin: '0px 0px -40px 0px' }).observe(bundle);
  }

  function initAll() {
    document.querySelectorAll('[data-frb-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-bind when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-frb-section]').forEach(initSection);
  });
})();
